var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVitalsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9.16412C22 9.1641 22 9.16408 22 9.16406C22 5.85035 19.3137 3.16406 16 3.16406C14.4633 3.16406 13.0615 3.74177 12 4.69185C10.9385 3.74177 9.53671 3.16406 8 3.16406C4.68629 3.16406 2 5.85035 2 9.16406C2 9.16409 2 9.16412 2 9.16415C2 16.5152 8.67146 19.9702 11.116 20.9894C11.6855 21.2269 12.3145 21.2269 12.884 20.9894C15.3285 19.9702 22 16.5152 22 9.16412Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.828 11.1641H17.1603L15.9201 8.27014C15.7625 7.90246 15.401 7.66406 15.0009 7.66406C14.6009 7.66406 14.2394 7.90246 14.0818 8.27014L12.0009 13.1255L11.4201 11.7701C11.2625 11.4025 10.901 11.1641 10.5009 11.1641H2.17383C2.29962 11.8732 2.49003 12.5393 2.73165 13.1641H9.84154L11.0818 16.058C11.2394 16.4257 11.6009 16.6641 12.0009 16.6641C12.401 16.6641 12.7625 16.4257 12.9201 16.058L15.0009 11.2027L15.5818 12.558C15.7394 12.9257 16.1009 13.1641 16.5009 13.1641H21.2702C21.5118 12.5393 21.7022 11.8732 21.828 11.1641Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsWhite);
export default __webpack_public_path__ + "static/media/vitals-white.3299979d0bdc84c6a40486c2d2092829.svg";
export { ForwardRef as ReactComponent };